import React, { FC } from 'react'
import { Theme } from '../../__styling'
import { EmailPreferenceSection, PreferenceSection } from './PreferenceSection'
import { StyledMastheadPreference } from './PreferenceSection.styled'

interface MastheadPreferenceProps {
    preferences: EmailPreferenceSection[]
    theme: Theme
    logo: JSX.Element
    isLoading: boolean
}

export const MastheadPreference: FC<MastheadPreferenceProps> = ({
    preferences,
    theme,
    logo,
    isLoading,
}) => {
    return (
        <StyledMastheadPreference>
            {logo}
            {preferences.map((preferenceSection, index) => (
                <PreferenceSection
                    section={preferenceSection}
                    key={index}
                    isLoading={isLoading}
                />
            ))}
        </StyledMastheadPreference>
    )
}
